import CityLandingPage from './page';

const guarulhosData = {
  cityName: 'Guarulhos',
  state: 'SP',
  slug: 'palestra-silenciosa-guarulhos',
  coordinates: { lat: -23.4531, lng: -46.5333 },
  phone: '(11) 91777-6227',
  localKeywords: [
    'palestra silenciosa guarulhos',
    'silent conference guarulhos sp',
    'aluguel fones sem fio guarulhos',
    'eventos corporativos guarulhos',
    'tradução simultânea guarulhos',
    'festa silenciosa guarulhos',
  ],
  heroTitle: 'palestra silenciosa guarulhos',
  heroSubtitle: 'Tecnologia de áudio sem fio premium para eventos corporativos em Guarulhos. Segunda maior cidade de SP, hub logístico estratégico com proximidade ao aeroporto internacional.',
  localStats: { clients: '50+', satisfaction: '96%' },
  localTestimonials: [],
  localFAQs: [
    { question: 'Vocês atendem toda a região de Guarulhos e arredores?', answer: 'Sim! Atendemos Guarulhos, Arujá, Itaquaquecetuba, Mairiporã e toda a região. Nossa localização estratégica permite chegar rapidamente em qualquer ponto da cidade.' },
    { question: 'Qual o prazo para contratar em Guarulhos?', answer: 'Recomendamos 1 a 2 semanas para eventos padrão. Para grandes convenções e eventos logísticos, sugerimos 3 semanas. Atendemos demandas urgentes com agilidade devido à nossa logística otimizada na região.' },
    { question: 'Os equipamentos são adequados para eventos próximos ao aeroporto?', answer: 'Sim! Nossos equipamentos operam em frequência dedicada e não sofrem interferência de sistemas aeroportuários. Já realizamos eventos a poucos metros do GRU Airport com desempenho impecável.' },
    { question: 'Quantos fones sem fio vocês disponibilizam em Guarulhos?', answer: 'De treinamentos logísticos (25 fones) a grandes convenções (300+ fones). Equipamentos resistentes e confiáveis, perfeitos para ambientes industriais e logísticos de Guarulhos.' },
    { question: 'Vocês atendem eventos nos hotéis e centros de convenções de Guarulhos?', answer: 'Sim, temos ampla experiência nos hotéis corporativos da região do aeroporto e nos centros de convenções de Guarulhos. Conhecemos bem a infraestrutura local e podemos recomendar os melhores venues para seu evento.' },
  ],
  seoTitle: 'Guarulhos Palestra Silenciosa | Aluguel Fones Sem Fio SP | STIB',
  seoDescription: 'Palestra silenciosa Guarulhos: aluguel de fones sem fio para eventos corporativos e treinamentos logísticos. Segunda maior cidade de SP com proximidade ao aeroporto. Solicite orçamento!',
  relatedCities: [
    { name: 'São Paulo (Capital)', slug: '/sao-paulo', region: 'Capital' },
    { name: 'Campinas', slug: '/campinas', region: 'Região Metropolitana' },
    { name: 'Barueri / Alphaville', slug: '/barueri', region: 'Grande SP Oeste' },
    { name: 'São José dos Campos', slug: '/sao-jose-dos-campos', region: 'Vale do Paraíba' },
    { name: 'Ribeirão Preto', slug: '/ribeirao-preto', region: 'Interior Norte' },
    { name: 'Santos', slug: '/santos', region: 'Baixada Santista' },
    { name: 'São Bernardo do Campo', slug: '/sao-bernardo-do-campo', region: 'ABCD Paulista' },
    { name: 'Jundiaí', slug: '/jundiai', region: 'Interior Oeste' },
  ],
};

export default function GuarulhosLandingPage() {
  return <CityLandingPage cityData={guarulhosData} />;
}